import copyPaste from './copy-paste';
import editor from './editor';
import general from './general';
import layersSelection from './layers-selection';
import leftPanels from './left-panels';
import textEditor from './text-editor';
import undoRedo from './undo-redo';
import viewModes from './view-modes';
import view from './view';

import SHORTCUT_TYPES from '../shortcut-types';

const types = {
  [SHORTCUT_TYPES.copyPaste.number]: copyPaste,
  [SHORTCUT_TYPES.editor.number]: editor,
  [SHORTCUT_TYPES.general.number]: general,
  [SHORTCUT_TYPES.layersSelection.number]: layersSelection,
  [SHORTCUT_TYPES.leftPanels.number]: leftPanels,
  [SHORTCUT_TYPES.textEditor.number]: textEditor,
  [SHORTCUT_TYPES.undoRedo.number]: undoRedo,
  [SHORTCUT_TYPES.viewModes.number]: viewModes,
  [SHORTCUT_TYPES.view.number]: view
};

const list = {};

for (const key in types) {
  for (const shortcutKey in types[key]) {
    const shortcut = types[key][shortcutKey];
    shortcut.type = parseInt(key);
    list[shortcutKey] = shortcut;
  }
}

export default list;
